<template>
  <div class="p-4">
    <div class="mb-4">
      <svg xmlns="http://www.w3.org/2000/svg" width="40" height="38" viewBox="0 0 40 38" fill="none" style="cursor: pointer;" @click="goBack()">
        <path d="M38.75 19.0003H1.25M1.25 19.0003L18.9583 1.29199M1.25 19.0003L18.9583 36.7087" stroke="#FF7C48" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </div>
    <h3>
      <h1 class="title">{{ header }}</h1>
    </h3>

    <!-- <div class="text-right">
      <div class="d-flex justify-content-end align-items-end">
        <div class="new-task-text mb-2 ml-2">
          <span @click="createSurvey">{{ $t("file-approval-survey.create") }}</span>
        </div>
        <div @click="createSurvey" class="plus-button "></div>
      </div>
    </div> -->

    <nav class="tab-menu">
      <div :class="{ active: selectedTab === 0 }" @click="selectedTab = 0">
        {{ $t("file-approval-survey.in-progress") }}
      </div>
      <div :class="{ active: selectedTab === 1 }" @click="selectedTab = 1">{{ $t("file-approval-survey.archive") }}</div>
    </nav>

    <div v-if="selectedTab === 0" :class="{ active: selectedTab === 0 }" class="mt-4">
      <div v-if="inProgressSurveyPagination">
        <div v-if="targetUrl && inProgressSurveyPagination.docs.length > 0">
          <button class="link-button mb-3" v-b-toggle.collapse-file-rocket><i class="iconoir-attachment"></i> {{ $t("file-manager.replace") }}</button>

          <b-collapse id="collapse-file-rocket" class="mt-2 mb-2">
            <div class="alert alert-warning">
              <ul>
                <li>
                  <p>{{ $t("file-approval-survey.replace-file") }}</p>
                </li>
              </ul>
            </div>
            <div class="d-flex align-items-center">
              <file-rocket
                :multiple="true"
                :allowedFormats="allowedFormats"
                @response="handleUploadResponse"
                :showProgress="'Upload'"
                :maxFileSize="600000000000"
                :maxFileLength="1"
                :targetUrl="targetUrl"
              >
              </file-rocket>
            </div>
          </b-collapse>
          <div v-if="file">
            <div class="d-flex align-items-center"></div>
            <div class="row">
              <div class="card shadow-none">
                <div class="card-body text-center d-flex align-items-center flex-column">
                  <div v-b-tooltip.hover :title="$options.filters.translate(file.name)" class="mb-2">
                    <file-icon class="hand" :extension="file.extension" />
                    <!--  <i :class="getIconClass(file.extension)" style="font-size:2rem;"></i>-->
                    <p v-if="file.approval && file.approval.path" class="card-text">{{ file.name | translate | summary(15) }}.{{ file.approval.path.split(".").pop() }}</p>
                    <p v-else class="card-text">{{ file.name | translate | summary(15) }}.{{ file.extension }}</p>
                  </div>
                  <div class="mt-auto">
                    <i @click="downloadFile(file)" v-b-tooltip.hover :title="$t('file-manager.download')" class="bx bxs-download text-dark hand mr-2" style="font-size:1.2rem;"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          :style="{ backgroundColor: backgroundColors[index % backgroundColors.length] }"
          class="card  p-2 rounded"
          v-for="(item, index) in inProgressSurveyPagination.docs"
          :key="item._id"
        >
          <b-row>
            <b-col md="10">
              <h5>
                {{ item.name | translate }}
              </h5>
            </b-col>
            <b-col md="2">
              <button v-b-tooltip.hover :title="$t('file-approval-survey.member.plural')" @click="redirectToMembers(item)" class="btn btn-light btn-sm mr-2 mt-2">
                <i class="mdi mdi-account-group font-size-16"></i>
              </button>
              <button v-b-tooltip.hover :title="$t('file-approval-survey.results')" @click="redirectToSurveyResults(item)" class="btn btn-light btn-sm mt-2">
                <i class="bx bxs-report font-size-20"></i></button
            ></b-col>
          </b-row>
        </div>
      </div>
      <empty v-if="!inProgressSurveyPagination || inProgressSurveyPagination.docs.length == 0">
        <h5 class="text-center">
          {{ $t("file-approval-survey.empty-in-progress") }}
        </h5>
      </empty>

      <div v-if="inProgressSurveyPagination" class="row">
        <div class="col">
          <ul class="pagination pagination-rounded mb-0">
            <b-pagination
              v-model="inProgressSurveysRequest.options.page"
              :total-rows="inProgressSurveyPagination.totalDocs"
              :per-page="inProgressSurveyPagination.limit"
              limit="10"
              size="sm"
            ></b-pagination>
          </ul>
        </div>
      </div>
    </div>
    <div v-if="selectedTab === 1" :class="{ active: selectedTab === 1 }" class="mt-4">
      <div v-if="complatedSurveyPagination">
        <div
          :style="{ backgroundColor: backgroundColors[index % backgroundColors.length] }"
          class="card p-2 rounded"
          v-for="(item, index) in complatedSurveyPagination.docs"
          :key="item._id"
        >
          <b-row class="row">
            <b-col md="10" class="">
              <h5>{{ item.name | translate }}</h5>
            </b-col>
            <b-col md="2" class="">
              <button v-b-tooltip.hover :title="$t('file-approval-survey.member.plural')" @click="redirectToMembers(item)" class="btn btn-light btn-sm mr-2 mt-2">
                <i class="mdi mdi-account-group font-size-16"></i>
              </button>
              <button v-b-tooltip.hover :title="$t('file-approval-survey.results')" @click="redirectToSurveyResults(item)" class="btn btn-light btn-sm mt-2">
                <i class="bx bxs-report font-size-20"></i>
              </button>
            </b-col>
          </b-row>
        </div>
      </div>
      <empty v-if="!complatedSurveyPagination || complatedSurveyPagination.docs.length == 0">
        <h5 class="text-center">
          {{ $t("file-approval-survey.empty-in-archived") }}
        </h5>
      </empty>

      <div class="row">
        <div class="col">
          <ul class="pagination pagination-rounded mb-0">
            <b-pagination
              v-model="complatedSurveysRequest.options.page"
              :total-rows="complatedSurveyPagination.totalDocs"
              :per-page="complatedSurveyPagination.limit"
              limit="10"
              size="sm"
            ></b-pagination>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FileRocket from "@c/form/file-rocket";
import OrganizationMemberSelect from "@cc/organization-member-select";
import FileIcon from "@modules/file-manager/file-icon.vue";
export default {
  components: { OrganizationMemberSelect, FileIcon, FileRocket },

  data() {
    return {
      backgroundColors: ["#556ee640", "#34c38f40"],
      allowedFormats: ["application/*", "image/*"],

      inProgressSurveysRequest: {
        options: { page: 1, limit: 15, sort: {} },
        query: {},
      },
      complatedSurveysRequest: {
        options: { page: 1, limit: 15, sort: {} },
        query: {},
      },
      selectedMember: undefined,
      form: {
        members: [],
      },
      targetUrl: undefined,
    };
  },
  async mounted() {
    await this.init();
  },
  watch: {
    inProgressSurveysRequest: {
      deep: true,
      immediate: true,
      handler() {
        this.debounce(() => this.fetchInProgressSurveys());
      },
    },
    complatedSurveysRequest: {
      deep: true,
      immediate: true,
      handler() {
        this.debounce(() => this.fetchComplatedSurveys());
      },
    },
    inProgressSurveyPagination: {
      deep: true,
      immediate: true,
      handler() {
        this.debounce(() => this.setTargetUrl());
      },
    },
  },
  computed: {
    selectedTab: {
      get() {
        return this.$store.getters["organizationFileApprovalSurvey/selectedTab"];
      },
      set(v) {
        this.$store.commit("organizationFileApprovalSurvey/selectedTab", v);
      },
    },
    isUploading() {
      return this.$store.getters["fileManager/isUploading"];
    },

    inProgressSurveyPagination() {
      return this.$store.getters[`organizationFileApprovalSurvey/inProgressSurveyPagination`];
    },
    complatedSurveyPagination() {
      return this.$store.getters[`organizationFileApprovalSurvey/complatedSurveyPagination`];
    },
    file() {
      return this.$store.getters["fileManager/selectedEntity"];
    },
    header() {
      return `${this.file?.no} - ${this.file?.name?.tr} - ${this.$t("file-approval-survey.plural")}`;
    },
  },

  methods: {
    async init() {
      if (this.$route.params.id) {
        await this.fetchDetail();
        await this.fetchInProgressSurveys();
        await this.fetchComplatedSurveys();
        this.setTargetUrl();
      }
    },
    handleUploadResponse(event) {
      if (!this.isUploading) {
        if (event && event?.status !== 200) {
          this.$handleHttpErrorByStatusCode(event?.error);
        }
        setTimeout(() => {
          this.init();
        }, 1000);
      }
    },
    setTargetUrl() {
      const survey = this.inProgressSurveyPagination?.docs[0];

      if (survey) {
        this.targetUrl = `/file-approval-survey/${survey?._id}/upload`;
      }
    },
    goBack() {
      this.$router.push(`/${this.currentProduct ? this.currentProduct.toLowerCase() : "organization"}/file-manager`);
    },
    redirectToMembers(item) {
      this.$store.commit("organizationFileApprovalSurvey/survey", item);
      this.$router.push(
        `/${this.currentProduct ? this.currentProduct.toLowerCase() : "organization"}/file-approval-survey/file/${this.$route.params.id}/survey/${item._id}/members`
      );
    },
    redirectToSurveyResults(item) {
      this.$store.commit("organizationFileApprovalSurvey/survey", item);
      this.$router.push(
        `/${this.currentProduct ? this.currentProduct.toLowerCase() : "organization"}/file-approval-survey/file/${this.$route.params.id}/survey/${item._id}/results`
      );
    },
    async fetchInProgressSurveys() {
      await this.$store.dispatch("organizationFileApprovalSurvey/fetchInProgressSurveys", { pagination: this.inProgressSurveysRequest, fileId: this.$route.params.id });
    },
    async fetchComplatedSurveys() {
      await this.$store.dispatch("organizationFileApprovalSurvey/fetchComplatedSurveys", { pagination: this.inProgressSurveysRequest, fileId: this.$route.params.id });
    },

    async fetchDetail() {
      const id = this.$route.params.id;
      try {
        const file = await this.$store.dispatch("fileManager/fetchDetail", id);
        this.$store.commit("fileManager/selectedEntity", file);
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },
    downloadFile(file) {
      let isApproval = false;
      if (file.approval?.path && file.approval.path != file.path) {
        isApproval = true;
      }

      this.$store.commit("fileManager/addDownloadedFile", { file, isApproval });
    },
    // async createSurvey() {
    //   // const ok = await this.confirm(this.$t("alert.approve"));
    //   // if (!ok) {
    //   //   return;
    //   // }
    //   try {
    //     const id = this.$route.params.id;
    //     this.form.id = id;
    //     await this.$store.dispatch("organizationFileApprovalSurvey/createSurvey", this.form);
    //     this.$toast.success(this.$t("common.success"));
    //     this.fetchInProgressSurveys();
    //   } catch (error) {
    //     this.$handleHttpErrorByStatusCode(error);;
    //   }
    // },
    async save() {
      const id = this.$route.params.id;
      this.form.id = id;
      await this.$store.dispatch("organizationFileApprovalSurvey/createSurvey", this.form);
      this.$root.$emit("bv::hide::modal", "modal-new-survey");
      this.fetchInProgressSurveys();
    },
  },
};
</script>

<style lang="scss" scoped>
@import url("../entity/organization-entities-view.scss");
</style>
